/* The Clay Arts: header, footer and homepage interactions (fh-*).
   Ported from clayart.uxsingh.in/assets/js/main.js. Differences: the cart is the real Shopify cart
   (Milano's own drawer), and the newsletter forms are real Shopify customer forms. */
(function () {
  'use strict';

  var doc = document.documentElement;
  var body = document.body;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  /* ---------------------------------------------------------
     Split headings into words for the blur-in effect
     --------------------------------------------------------- */
  function splitWords(el) {
    var index = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
            } else {
              var span = document.createElement('span');
              span.className = 'w';
              span.textContent = part;
              span.style.setProperty('--i', index++);
              frag.appendChild(span);
            }
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    })(el);
  }

  each(document.querySelectorAll('.fh [data-split]'), splitWords);

  /* ---------------------------------------------------------
     Load sequence (hero)
     --------------------------------------------------------- */
  var heroTitle = document.querySelector('.fh [data-split="load"]');
  if (heroTitle) heroTitle.style.setProperty('--d', '.25s');

  function start() {
    var run = function () {
      doc.classList.add('fh-loaded');
      if (heroTitle) heroTitle.classList.add('in');
    };
    requestAnimationFrame(run);
    setTimeout(run, 1500);
  }
  if (document.fonts && document.fonts.ready) {
    var started = false;
    var go = function () { if (!started) { started = true; start(); } };
    document.fonts.ready.then(go);
    setTimeout(go, 900);
  } else {
    start();
  }

  /* ---------------------------------------------------------
     Scroll reveals
     --------------------------------------------------------- */
  var revealEls = document.querySelectorAll('.fh [data-reveal], .fh [data-split]:not([data-split="load"])');
  // Cards in a sideways-scrolling row (videos, New arrivals on phones) reveal together with their row.
  // Watched one by one, the cards still off to the side stayed 30px low and jumped up while swiping.
  var ROWS = '.fh-sv-track, .fh-products--scroll, .fh-benefits';
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var t = entry.target;
          if (t.matches(ROWS)) each(t.querySelectorAll('[data-reveal]'), function (c) { c.classList.add('in'); });
          else t.classList.add('in');
          io.unobserve(t);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    each(revealEls, function (el) {
      var row = el.parentElement && el.parentElement.closest(ROWS);
      if (row && el.parentElement === row) return;
      io.observe(el);
    });
    each(document.querySelectorAll('.fh ' + ROWS.split(', ').join(', .fh ')), function (row) { io.observe(row); });
  } else {
    each(revealEls, function (el) { el.classList.add('in'); });
  }

  /* ---------------------------------------------------------
     Navbar: transparent over the hero, solid after it (always
     solid on pages without the hero), hides on scroll down
     --------------------------------------------------------- */
  var nav = document.getElementById('fh-nav');
  var hero = document.querySelector('.fh-hero');
  var navSpacer = document.querySelector('.fh-nav-spacer');
  var lastY = window.scrollY;
  var ticking = false;
  var anyOverlayOpen = false;

  function updateNav() {
    if (!nav) return;
    var y = window.scrollY;
    var past = hero ? y > hero.offsetHeight - nav.offsetHeight : true;
    nav.classList.toggle('is-solid', past);
    if (navSpacer) navSpacer.style.height = nav.offsetHeight + 'px';

    if (!anyOverlayOpen) {
      var hideFrom = hero ? past : y > nav.offsetHeight;
      if (hideFrom && y > lastY + 4) nav.classList.add('is-hidden');
      else if (y < lastY - 4 || !hideFrom) nav.classList.remove('is-hidden');
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(updateNav); }
    maybeShowPopup();
  }, { passive: true });
  updateNav();

  /* ---------------------------------------------------------
     Overlays: menu, search, popup, video viewer
     --------------------------------------------------------- */
  var openOverlay = null;
  var lastFocus = null;

  function setOpen(overlay, open) {
    if (!overlay) return;
    overlay.classList.toggle('is-open', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');

    each(document.querySelectorAll('[data-fh-open="' + overlay.id + '"]'), function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (open) {
      if (openOverlay && openOverlay !== overlay) setOpen(openOverlay, false);
      lastFocus = document.activeElement;
      openOverlay = overlay;
      anyOverlayOpen = true;
      body.classList.add('fh-locked');
      var focusable = overlay.querySelector('button, a[href], input:not([type="hidden"])');
      if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
    } else if (openOverlay === overlay) {
      openOverlay = null;
      anyOverlayOpen = false;
      body.classList.remove('fh-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    overlay.dispatchEvent(new CustomEvent(open ? 'overlay:open' : 'overlay:close'));
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-fh-open]');
    if (opener) {
      e.preventDefault();
      opener.focus({ preventScroll: true });
      setOpen(document.getElementById(opener.getAttribute('data-fh-open')), true);
      return;
    }
    var closer = e.target.closest('[data-fh-close]');
    if (closer) {
      var overlay = closer.closest('[role="dialog"]');
      if (overlay) {
        if (overlay.id === 'fh-popup') rememberPopup();
        setOpen(overlay, false);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openOverlay) return;
    if (e.key === 'Escape') {
      if (openOverlay.id === 'fh-popup') rememberPopup();
      setOpen(openOverlay, false);
      return;
    }
    if (e.key === 'Tab') {
      var items = openOverlay.querySelectorAll('button, a[href], input:not([type="hidden"])');
      items = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------------------------------------------------
     Newsletter popup: once per visitor, after the first real
     scroll into the collections section
     --------------------------------------------------------- */
  var popup = document.getElementById('fh-popup');
  var collections = document.querySelector('.fh-collections') || document.querySelector('[data-fh-popup-trigger]');
  var POPUP_KEY = 'tca-popup-dismissed';
  var popupDone = false;

  function popupDismissed() {
    try { return window.localStorage.getItem(POPUP_KEY) === '1'; } catch (err) { return false; }
  }
  function rememberPopup() {
    popupDone = true;
    try { window.localStorage.setItem(POPUP_KEY, '1'); } catch (err) { /* storage unavailable */ }
  }
  if (popupDismissed() || window.Shopify && window.Shopify.designMode) popupDone = true;

  function maybeShowPopup() {
    if (popupDone || openOverlay || !collections || !popup) return;
    if (collections.getBoundingClientRect().top < window.innerHeight * 0.35) {
      popupDone = true;
      setTimeout(function () { if (!openOverlay) setOpen(popup, true); }, 600);
    }
  }

  /* ---------------------------------------------------------
     Search: an empty search keeps focus in the field
     --------------------------------------------------------- */
  var searchForm = document.querySelector('[data-fh-search-form]');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      var q = searchForm.querySelector('input[name="q"]');
      if (!q.value.trim()) {
        e.preventDefault();
        q.focus();
      }
    });
  }

  /* ---------------------------------------------------------
     Newsletter forms (real Shopify customer forms): check the
     email first; the store shows the thank-you after the post
     --------------------------------------------------------- */
  each(document.querySelectorAll('form.fh-popup-form, form.fh-nl-form'), function (form) {
    form.noValidate = true;
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      var note = form.querySelector('.fh-form-note');
      var ok = input && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
      if (!ok) {
        e.preventDefault();
        if (note) note.textContent = 'Please enter a valid email address.';
        input.focus();
        return;
      }
      if (form.closest('.fh-popup')) rememberPopup();
    });
  });

  /* ---------------------------------------------------------
     Cart: the real Shopify cart. Adds go through /cart/add.js,
     then Milano's own drawer is refreshed and opened (the same
     steps theme.js runs after its product-form add)
     --------------------------------------------------------- */
  var cartCount = document.querySelector('[data-fh-cart-count]');
  var cartStatus = document.querySelector('[data-fh-cart-status]');
  var cartButton = document.querySelector('.fh-cart-btn');

  function setCount(count) {
    if (cartCount) {
      cartCount.hidden = !count;
      cartCount.textContent = count > 99 ? '99+' : String(count);
    }
    if (cartButton) cartButton.setAttribute('aria-label', count ? 'Open cart, ' + count + (count === 1 ? ' item' : ' items') : 'Open cart');
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        each(document.querySelectorAll('.cart-count'), function (el) {
          if (el.closest('.fh')) return;
          el.textContent = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : cart.item_count;
        });
        var total = document.querySelector('header-total-price');
        if (total && typeof total.updateTotal === 'function') total.updateTotal(cart);
        var freeShip = document.querySelector('free-ship-progress-bar');
        if (freeShip && typeof freeShip.init === 'function') freeShip.init(cart.items_subtotal_price);
        return cart;
      })
      .catch(function () {});
  }

  function openCart() {
    var drawer = document.querySelector('cart-notification');
    var target = document.getElementById('minicart-form');
    if (!drawer || !target || typeof drawer.open !== 'function') {
      window.location.href = root + 'cart';
      return;
    }
    fetch(root + '?sections=minicart-form', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = new DOMParser().parseFromString(sections['minicart-form'], 'text/html');
        var fresh = html.querySelector('#minicart-form');
        if (fresh) target.innerHTML = fresh.innerHTML;
        if (typeof drawer.cartAction === 'function') drawer.cartAction();
      })
      .catch(function () {})
      .then(function () { refreshCart(); drawer.open(); });
  }
  window.FH_openCart = openCart;

  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-fh-cart-open]');
    if (cartBtn) { e.preventDefault(); openCart(); return; }

    var btn = e.target.closest('[data-fh-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        if (!res.ok) {
          if (cartStatus) cartStatus.textContent = res.data.description || res.data.message || 'Could not add to cart';
          window.alert(res.data.description || res.data.message || 'Could not add to cart');
          return;
        }
        if (cartStatus) cartStatus.textContent = (btn.getAttribute('data-title') || 'Item') + ' added to cart';
        if (cartCount) {
          cartCount.classList.add('is-bump');
          setTimeout(function () { cartCount.classList.remove('is-bump'); }, 300);
        }
        // Brief "Added" state: text buttons swap their label, icon buttons show a check (CSS)
        var label = btn.firstChild && btn.firstChild.nodeType === 3 && btn.firstChild.nodeValue.trim() ? btn.firstChild : null;
        var text = label ? label.nodeValue : '';
        btn.classList.add('is-added');
        if (label) label.nodeValue = 'Added';
        clearTimeout(btn.addedTimer);
        btn.addedTimer = setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.nodeValue = text;
        }, 1600);
        if (openOverlay) setOpen(openOverlay, false);
        openCart();
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------------------------------------------------------
     Testimonials slider
     --------------------------------------------------------- */
  var tSection = document.querySelector('.fh [data-carousel]');
  if (tSection) {
    var slides = tSection.querySelectorAll('.fh-t-slide');
    var dots = tSection.querySelectorAll('.fh-t-dots button');
    var tIndex = 0, tTimer = null, tPaused = false, tVisible = false, touchX = null;

    tSection.setAttribute('aria-roledescription', 'carousel');
    each(slides, function (s, i) {
      s.setAttribute('role', 'group');
      s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
    });

    var showSlide = function (n) {
      tIndex = (n + slides.length) % slides.length;
      each(slides, function (s, i) {
        s.classList.toggle('is-active', i === tIndex);
        s.setAttribute('aria-hidden', i === tIndex ? 'false' : 'true');
      });
      each(dots, function (d, i) {
        d.setAttribute('aria-current', i === tIndex ? 'true' : 'false');
      });
    };
    var restartTimer = function () {
      clearInterval(tTimer);
      if (!reduceMotion && slides.length > 1) {
        tTimer = setInterval(function () { if (!tPaused && tVisible) showSlide(tIndex + 1); }, 7000);
      }
    };

    tSection.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-t-dir]');
      var dot = e.target.closest('.fh-t-dots button');
      if (arrow) showSlide(tIndex + parseInt(arrow.getAttribute('data-t-dir'), 10));
      else if (dot) showSlide(Array.prototype.indexOf.call(dots, dot));
      else return;
      restartTimer();
    });
    tSection.addEventListener('mouseenter', function () { tPaused = true; });
    tSection.addEventListener('mouseleave', function () { tPaused = false; });
    tSection.addEventListener('focusin', function () { tPaused = true; });
    tSection.addEventListener('focusout', function () { tPaused = false; });
    tSection.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    tSection.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { showSlide(tIndex + (dx < 0 ? 1 : -1)); restartTimer(); }
      touchX = null;
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { tVisible = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(tSection);
    } else {
      tVisible = true;
    }
    restartTimer();
  }

  /* ---------------------------------------------------------
     FAQ accordion
     --------------------------------------------------------- */
  each(document.querySelectorAll('.fh-faq-q button'), function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.fh-faq-item');
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------------------------------------------------------
     Shoppable videos: cards play muted while on screen;
     tapping one opens the viewer with sound and the product
     --------------------------------------------------------- */
  var svTrack = document.getElementById('fh-sv-track');
  var svModal = document.getElementById('fh-sv-modal');
  var svDataEl = document.getElementById('fh-sv-data');
  if (svTrack && svModal && svDataEl) {
    var svItems = [];
    try { svItems = JSON.parse(svDataEl.textContent); } catch (err) { svItems = []; }
    var svCards = svTrack.querySelectorAll('.fh-sv-card');
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    var svAutoplay = !reduceMotion && !saveData;
    var svViewerOpen = false;

    var cardVideo = function (card) { return card.querySelector('.fh-sv-video'); };
    var playCard = function (card) {
      var v = cardVideo(card);
      if (!v) return;
      if (!v.getAttribute('src') && v.getAttribute('data-src')) {
        v.preload = 'auto';
        v.src = v.getAttribute('data-src');
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused: the poster stays */ });
    };
    each(svCards, function (card) {
      var v = cardVideo(card);
      if (v) v.addEventListener('playing', function () { card.classList.add('is-playing'); });
    });

    if (svAutoplay && 'IntersectionObserver' in window) {
      var svObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          card.svVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          if (card.svVisible && !svViewerOpen) playCard(card);
          else if (cardVideo(card)) cardVideo(card).pause();
        });
      }, { threshold: [0, 0.6] });
      each(svCards, function (card) { svObserver.observe(card); });
    }

    var svStepWidth = function () {
      var gap = parseFloat(getComputedStyle(svTrack).columnGap) || 0;
      return svCards.length ? svCards[0].getBoundingClientRect().width + gap : svTrack.clientWidth;
    };
    var svDrag = null, svDragged = false, svSnapTimer;
    svTrack.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || svTrack.scrollWidth <= svTrack.clientWidth) return;
      svDrag = { x: e.clientX, left: svTrack.scrollLeft };
      svDragged = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!svDrag) return;
      var dx = e.clientX - svDrag.x;
      if (!svDragged && Math.abs(dx) > 6) {
        svDragged = true;
        clearTimeout(svSnapTimer);
        svTrack.classList.add('is-dragging');
      }
      if (svDragged) svTrack.scrollLeft = svDrag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!svDrag) return;
      svDrag = null;
      if (!svDragged) return;
      var step = svStepWidth();
      var max = svTrack.scrollWidth - svTrack.clientWidth;
      svTrack.scrollTo({ left: Math.min(max, Math.round(svTrack.scrollLeft / step) * step), behavior: reduceMotion ? 'auto' : 'smooth' });
      svSnapTimer = setTimeout(function () { svTrack.classList.remove('is-dragging'); }, reduceMotion ? 0 : 450);
    });
    svTrack.addEventListener('click', function (e) {
      if (!svDragged) return;
      svDragged = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    svTrack.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Viewer
    var svmVideo = svModal.querySelector('.fh-svm-video');
    var svmBar = svModal.querySelector('.fh-svm-progress span');
    var svmSound = svModal.querySelector('.fh-svm-sound');
    var svmThumb = svModal.querySelector('.fh-svm-thumb');
    var svmName = svModal.querySelector('.fh-svm-name');
    var svmNow = svModal.querySelector('.fh-svm-now');
    var svmWas = svModal.querySelector('.fh-svm-was');
    var svmDesc = svModal.querySelector('.fh-svm-desc');
    var svmOptions = svModal.querySelector('.fh-svm-options');
    var svmPills = svModal.querySelector('.fh-svm-pills');
    var svmAdd = svModal.querySelector('.fh-svm-add');
    var svmLink = svModal.querySelector('.fh-svm-link');
    var svmStatus = svModal.querySelector('[data-svm-status]');
    var svIndex = 0, svSound = true, svRaf = 0, svTouchX = null, svTouchY = 0;

    var money = function (cents) {
      var fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify && window.Shopify.money_format) || 'Rs. {{amount}}';
      var amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount);
    };
    var make = function (tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = text;
      return node;
    };
    var setSvSound = function (on) {
      svSound = on;
      svmVideo.muted = !on;
      svmSound.classList.toggle('is-muted', !on);
      svmSound.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
    };
    var playViewer = function () {
      var p = svmVideo.play();
      if (p && p.catch) {
        p.catch(function (err) {
          if (err && err.name === 'NotAllowedError' && !svmVideo.muted) {
            setSvSound(false);
            var again = svmVideo.play();
            if (again && again.catch) again.catch(function () {});
          }
        });
      }
    };
    var selectSvVariant = function (item, k) {
      var v = item.variants[k];
      svmNow.textContent = money(v.price);
      svmWas.textContent = v.compare && v.compare > v.price ? money(v.compare) : '';
      svmAdd.setAttribute('data-variant', v.id);
      svmAdd.setAttribute('data-title', item.title);
      svmAdd.disabled = !v.available;
      svmAdd.firstChild.nodeValue = v.available ? 'Add to cart' : 'Sold out';
    };
    var renderViewer = function (i) {
      if (!svItems.length) return;
      svIndex = (i + svItems.length) % svItems.length;
      var item = svItems[svIndex];
      svmVideo.poster = item.poster || '';
      svmVideo.src = item.video;
      svmVideo.muted = !svSound;
      svmBar.style.transform = 'scaleX(0)';
      svmThumb.src = item.image || '';
      svmName.textContent = item.title;
      svmDesc.textContent = item.desc;
      svmLink.href = item.url;
      svmPills.textContent = '';
      svmOptions.hidden = item.variants.length < 2;
      var first = 0;
      for (var f = 0; f < item.variants.length; f++) { if (item.variants[f].available) { first = f; break; } }
      if (item.variants.length > 1) {
        item.variants.forEach(function (v, k) {
          var pill = make('label', 'fh-svm-pill');
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'svm-variant';
          input.value = String(k);
          input.checked = k === first;
          input.addEventListener('change', function () { selectSvVariant(item, k); });
          pill.appendChild(input);
          pill.appendChild(make('span', null, v.title));
          svmPills.appendChild(pill);
        });
      }
      selectSvVariant(item, first);
      svmStatus.textContent = 'Video ' + (svIndex + 1) + ' of ' + svItems.length + ': ' + item.title;
      playViewer();
    };
    var tickSvProgress = function () {
      if (svmVideo.duration) svmBar.style.transform = 'scaleX(' + (svmVideo.currentTime / svmVideo.duration) + ')';
      svRaf = requestAnimationFrame(tickSvProgress);
    };

    svTrack.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-sv-open]');
      if (!opener) return;
      svViewerOpen = true;
      each(svCards, function (c) { if (cardVideo(c)) cardVideo(c).pause(); });
      opener.focus({ preventScroll: true });
      renderViewer(parseInt(opener.getAttribute('data-sv-open'), 10));
      setOpen(svModal, true);
    });
    svModal.addEventListener('overlay:open', function () {
      cancelAnimationFrame(svRaf);
      svRaf = requestAnimationFrame(tickSvProgress);
    });
    svModal.addEventListener('overlay:close', function () {
      svViewerOpen = false;
      cancelAnimationFrame(svRaf);
      svmVideo.pause();
      each(svCards, function (c) { if (c.svVisible) playCard(c); });
    });
    svModal.addEventListener('click', function (e) {
      var step = e.target.closest('[data-svm-step]');
      if (step) { renderViewer(svIndex + parseInt(step.getAttribute('data-svm-step'), 10)); return; }
      if (e.target.closest('.fh-svm-sound')) {
        setSvSound(!svSound);
        if (svmVideo.paused) playViewer();
        return;
      }
      if (e.target === svmVideo) {
        if (svmVideo.paused) playViewer(); else svmVideo.pause();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!svModal.classList.contains('is-open') || (e.target && e.target.type === 'radio')) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        renderViewer(svIndex + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    svModal.addEventListener('touchstart', function (e) {
      svTouchX = e.touches[0].clientX;
      svTouchY = e.touches[0].clientY;
    }, { passive: true });
    svModal.addEventListener('touchend', function (e) {
      if (svTouchX === null) return;
      var dx = e.changedTouches[0].clientX - svTouchX;
      var dy = e.changedTouches[0].clientY - svTouchY;
      svTouchX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && !e.target.closest('.fh-svm-panel')) {
        renderViewer(svIndex + (dx < 0 ? 1 : -1));
      }
    });
  }

  /* ---------------------------------------------------------
     Photo hotspots (gift sets)
     --------------------------------------------------------- */
  var hotspots = Array.prototype.slice.call(document.querySelectorAll('.fh-hotspot'));
  if (hotspots.length) {
    var placeCard = function (spot) {
      var card = spot.querySelector('.fh-hs-card');
      var frame = spot.offsetParent;
      if (!card || !frame) return;
      var fw = frame.clientWidth, fh = frame.clientHeight;
      var x = spot.offsetLeft, y = spot.offsetTop, gap = 28, edge = 8;
      var w = Math.min(280, fw - 2 * edge);
      card.style.width = w + 'px';
      card.classList.toggle('fh-hs-card--compact', w < 250);
      var h = card.offsetHeight;
      var left = Math.max(edge, Math.min(x - w / 2, fw - w - edge));
      var top = y + gap + h <= fh - edge ? y + gap
        : y - gap - h >= edge ? y - gap - h
        : Math.max(edge, fh - h - edge);
      card.style.left = Math.round(left - x) + 'px';
      card.style.top = Math.round(top - y) + 'px';
      card.style.transformOrigin = Math.round(x - left) + 'px ' + (top > y ? '0' : '100%');
    };
    var placeAllCards = function () { hotspots.forEach(placeCard); };
    var setSpot = function (spot, open) {
      spot.classList.toggle('is-open', open);
      spot.querySelector('.fh-hs-dot').setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) spot.classList.remove('is-dismissed');
    };

    hotspots.forEach(function (spot) {
      spot.addEventListener('pointerenter', function () { placeCard(spot); });
      spot.addEventListener('focusin', function () { placeCard(spot); });
      spot.addEventListener('pointerleave', function () { spot.classList.remove('is-dismissed'); });
      spot.addEventListener('focusout', function (e) {
        if (!spot.contains(e.relatedTarget)) spot.classList.remove('is-dismissed');
      });
    });

    document.addEventListener('click', function (e) {
      var inside = e.target.closest('.fh-hotspot');
      hotspots.forEach(function (spot) { if (spot !== inside) setSpot(spot, false); });
      if (!inside) return;
      if (e.target === inside || e.target.closest('.fh-hs-dot')) {
        placeCard(inside);
        setSpot(inside, !inside.classList.contains('is-open'));
      } else if (e.target.closest('[data-fh-add]')) {
        setSpot(inside, true);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || openOverlay) return;
      hotspots.forEach(function (spot) {
        if (spot.classList.contains('is-open') || spot.contains(document.activeElement) || spot.matches(':hover')) {
          setSpot(spot, false);
          spot.classList.add('is-dismissed');
        }
      });
    }, true);

    placeAllCards();
    window.addEventListener('resize', placeAllCards);
    window.addEventListener('load', placeAllCards);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeAllCards);
  }

  /* ---------------------------------------------------------
     Footer wordmark: fit to the container width
     --------------------------------------------------------- */
  var mark = document.querySelector('.fh-f-mark');
  var markText = mark && mark.querySelector('span');
  function fitMark() {
    if (!mark || !markText) return;
    mark.style.fontSize = '100px';
    var w = markText.getBoundingClientRect().width;
    var target = mark.clientWidth;
    if (w > 0) mark.style.fontSize = (100 * target / w).toFixed(2) + 'px';
  }
  fitMark();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMark);
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { fitMark(); updateNav(); }, 120);
  });

  /* ---------------------------------------------------------
     Hero video: mobile/desktop file chosen by screen shape,
     paused off-screen, poster shown when it can't play
     --------------------------------------------------------- */
  var video = document.querySelector('.fh-hero-video');
  if (video) {
    var heroInView = true;
    var videoOff = function () {
      video.pause();
      if (hero) hero.classList.add('is-video-off');
    };
    var playVideo = function () {
      var p = video.play();
      if (p && p.catch) {
        p.catch(function (err) {
          if (err && err.name === 'NotAllowedError') videoOff();
        });
      }
    };
    if (reduceMotion) {
      video.removeAttribute('autoplay');
      each(video.querySelectorAll('source'), function (s) { s.parentNode.removeChild(s); });
      video.load();
      videoOff();
    } else {
      var portrait = window.matchMedia('(max-aspect-ratio: 4/5)');
      var onShapeChange = function () {
        video.load();
        if (heroInView) playVideo();
      };
      if (portrait.addEventListener) portrait.addEventListener('change', onShapeChange);
      else if (portrait.addListener) portrait.addListener(onShapeChange);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            heroInView = entry.isIntersecting;
            if (heroInView) playVideo(); else video.pause();
          });
        }, { threshold: 0.05 }).observe(video);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && heroInView) playVideo();
      });
    }
  }

  /* ---------------------------------------------------------
     Collection page (fh-collection): chips, sort, filters and
     Load more swap content in place through the Section
     Rendering API; every state keeps a real collection URL
     --------------------------------------------------------- */
  var catalog = document.querySelector('[data-fh-catalog]');
  if (catalog) {
    var sectionId = catalog.getAttribute('data-section-id');
    var catHero = document.querySelector('[data-fh-catalog-hero]');
    var catToken = 0;
    var observeIn = function (scope) {
      each(scope.querySelectorAll('[data-reveal], [data-split]:not([data-split="load"])'), function (el) {
        if (io && !reduceMotion) io.observe(el); else el.classList.add('in');
      });
    };
    var sectionUrl = function (url) {
      var u = new URL(url, window.location.href);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    };
    var fetchSection = function (url) {
      return fetch(sectionUrl(url), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
    };
    var cleanUrl = function (url) {
      var u = new URL(url, window.location.href);
      u.searchParams.delete('section_id');
      u.searchParams.delete('page');
      return u.pathname + (u.search || '');
    };
    var announceCat = function (text) {
      var st = catalog.querySelector('[data-fh-catalog-status]');
      if (!st) return;
      st.textContent = '';
      setTimeout(function () { st.textContent = text; }, 60);
    };

    // Banner: new title and intro replay their entrance; a new photo fades in over the old one
    var swapHero = function (doc) {
      var next = doc.querySelector('[data-fh-catalog-hero]');
      if (!next || !catHero) return;
      var title = catHero.querySelector('[data-fh-catalog-title]');
      var nTitle = next.querySelector('[data-fh-catalog-title]');
      if (title && nTitle && title.innerHTML.replace(/<[^>]+>/g, '') !== nTitle.textContent) {
        title.classList.remove('in');
        title.innerHTML = nTitle.innerHTML;
        splitWords(title);
        void title.offsetWidth;
        title.classList.add('in');
        document.title = nTitle.textContent.trim() + ' – ' + (document.title.split(' – ').pop() || '');
      }
      var intro = catHero.querySelector('[data-fh-catalog-intro]');
      var nIntro = next.querySelector('[data-fh-catalog-intro]');
      if (intro && nIntro && intro.textContent !== nIntro.textContent) {
        intro.textContent = nIntro.textContent;
        intro.classList.remove('is-swapped');
        void intro.offsetWidth;
        intro.classList.add('is-swapped');
      }
      var media = catHero.querySelector('.fh-hero-media');
      var nImg = next.querySelector('.fh-hero-media img');
      var shown = media.querySelectorAll('img.is-current');
      var top = shown[shown.length - 1];
      if (!nImg || (top && top.getAttribute('data-file') === nImg.getAttribute('data-file'))) return;
      var img = nImg.cloneNode(true);
      img.classList.remove('is-current');
      img.removeAttribute('fetchpriority');
      img.loading = 'eager';
      media.appendChild(img);
      var done = function () {
        requestAnimationFrame(function () {
          img.classList.add('is-current');
          setTimeout(function () {
            each(media.querySelectorAll('img'), function (o) { if (o !== img) o.parentNode.removeChild(o); });
          }, reduceMotion ? 0 : 950);
        });
      };
      if (img.decode) img.decode().then(done, done); else img.onload = done;
    };

    var loadCatalog = function (url, opts) {
      opts = opts || {};
      var token = ++catToken;
      catalog.setAttribute('aria-busy', 'true');
      if (openOverlay) setOpen(openOverlay, false);
      return fetchSection(url).then(function (doc) {
        if (token !== catToken) return;
        var next = doc.querySelector('[data-fh-catalog]');
        if (!next) { window.location.href = url; return; }
        catalog.innerHTML = next.innerHTML;
        catalog.removeAttribute('aria-busy');
        setTimeout(function () { if (updateMbar) updateMbar(); }, 60);
        observeIn(catalog);
        swapHero(doc);
        if (opts.push !== false) window.history.pushState({ fhCatalog: true }, '', cleanUrl(url));
        var count = catalog.querySelector('[data-fh-count]');
        if (count) announceCat(count.textContent);
        if (opts.scroll) window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      }).catch(function () { window.location.href = url; });
    };

    var formUrl = function (form) {
      var u = new URL(form.getAttribute('action'), window.location.href);
      var fd = new FormData(form);
      fd.forEach(function (v, k) { if (String(v).trim() !== '') u.searchParams.append(k, v); });
      return u.toString();
    };

    catalog.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fh-chip]');
      if (chip && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
        e.preventDefault();
        // a category chip keeps the chosen sort
        var u = new URL(chip.href, window.location.href);
        var sort = new URLSearchParams(window.location.search).get('sort_by');
        if (sort && !u.searchParams.get('sort_by') && !chip.classList.contains('fh-fsheet-clear')) u.searchParams.set('sort_by', sort);
        loadCatalog(u.toString(), { scroll: true });
        return;
      }
      var more = e.target.closest('[data-fh-load]');
      if (more) {
        var nextUrl = more.getAttribute('data-next');
        if (!nextUrl || more.getAttribute('aria-busy') === 'true') return;
        more.setAttribute('aria-busy', 'true');
        var grid = catalog.querySelector('[data-fh-grid]');
        var before = grid.children.length;
        fetchSection(nextUrl).then(function (doc) {
          var nGrid = doc.querySelector('[data-fh-grid]');
          var nMore = doc.querySelector('[data-fh-more]');
          each(Array.prototype.slice.call(nGrid ? nGrid.children : []), function (c) {
            grid.appendChild(c);
            if (io && !reduceMotion) io.observe(c); else c.classList.add('in');
          });
          var block = catalog.querySelector('[data-fh-more]');
          if (nMore && block) block.outerHTML = nMore.outerHTML; else if (block) block.hidden = true;
          var first = grid.children[before];
          if (first) { var l = first.querySelector('.fh-pc-link'); if (l) l.focus({ preventScroll: true }); }
          var prog = catalog.querySelector('[data-fh-progress]');
          announceCat(prog ? prog.textContent : '');
        }).catch(function () { more.removeAttribute('aria-busy'); });
        return;
      }
      var tab = e.target.closest('[data-fh-sheet-tab]');
      if (tab) {
        var g = catalog.querySelector('[data-fh-group="' + tab.getAttribute('data-fh-sheet-tab') + '"]');
        if (g) setTimeout(function () { g.scrollIntoView({ block: 'start' }); }, 80);
      }
    });

    catalog.addEventListener('change', function (e) {
      var sort = e.target.closest('[data-fh-sort]');
      if (sort) {
        var u = new URL(window.location.href);
        if (sort.value) u.searchParams.set('sort_by', sort.value); else u.searchParams.delete('sort_by');
        u.searchParams.delete('page');
        loadCatalog(u.toString());
        return;
      }
      // Bottom sheet: a change updates the "Show N products" count before applying
      var form = e.target.closest('[data-fh-filter-form]');
      if (!form) return;
      var apply = form.querySelector('[data-fh-apply]');
      var url = formUrl(form);
      form.setAttribute('data-url', url);
      fetchSection(url).then(function (doc) {
        if (form.getAttribute('data-url') !== url) return;
        var c = doc.querySelector('[data-fh-count]');
        var n = c ? parseInt(c.getAttribute('data-fh-count'), 10) : 0;
        if (apply) apply.textContent = n ? 'Show ' + n + (n === 1 ? ' product' : ' products') : 'No products';
        if (apply) apply.disabled = !n;
      });
    });

    catalog.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-fh-filter-form]');
      if (!form) return;
      e.preventDefault();
      loadCatalog(formUrl(form), { scroll: true });
    });

    // Phones: the Filter / Sort bar floats at the bottom of the collection page
    var mbarTick = false;
    var updateMbar = function () {
      mbarTick = false;
      var r = catalog.getBoundingClientRect();
      var vh = window.innerHeight;
      // shown the whole time on the collection page (the client asked); hidden only while a dialog is open (CSS)
      catalog.classList.add('fh-mbar-on');
    };
    window.addEventListener('scroll', function () {
      if (!mbarTick) { mbarTick = true; requestAnimationFrame(updateMbar); }
    }, { passive: true });
    window.addEventListener('resize', updateMbar);
    updateMbar();

    window.addEventListener('popstate', function () {
      loadCatalog(window.location.href, { push: false });
    });

    // Quick add for products with options
    var qa = document.getElementById('fh-quick-add');
    if (qa) {
      var q = function (sel) { return qa.querySelector(sel); };
      var qaMoney = function (cents) {
        var fmt = (window.theme && window.theme.moneyFormat) || 'Rs. {{amount}}';
        return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      };
      var qaSelect = function (p, k) {
        var v = p.variants[k];
        q('[data-fh-qa-now]').textContent = qaMoney(v.price);
        q('[data-fh-qa-was]').textContent = v.compare > v.price ? qaMoney(v.compare) : '';
        var add = q('[data-fh-qa-add]');
        add.setAttribute('data-variant', v.id);
        add.setAttribute('data-title', p.title);
        add.disabled = !v.available;
      };
      catalog.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fh-qa]');
        if (!btn) return;
        var raw = btn.parentNode.querySelector('[data-fh-qa-data]');
        var p;
        try { p = JSON.parse(raw.textContent); } catch (err) { return; }
        q('[data-fh-qa-img]').src = p.image || '';
        q('[data-fh-qa-img]').alt = p.title;
        q('[data-fh-qa-thumb]').src = p.thumb || '';
        q('[data-fh-qa-name]').textContent = p.title;
        q('[data-fh-qa-desc]').textContent = p.desc || '';
        q('[data-fh-qa-link]').href = p.url;
        var pills = q('[data-fh-qa-pills]');
        pills.textContent = '';
        var first = -1;
        p.variants.forEach(function (v, k) {
          var pill = document.createElement('label');
          pill.className = 'fh-svm-pill';
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'fh-qa-variant';
          input.value = String(k);
          input.disabled = !v.available;
          input.addEventListener('change', function () { qaSelect(p, k); });
          var text = document.createElement('span');
          text.textContent = v.title;
          if (!v.available) {
            var note = document.createElement('span');
            note.className = 'fh-sr-only';
            note.textContent = ' (sold out)';
            text.appendChild(note);
          }
          pill.appendChild(input);
          pill.appendChild(text);
          pills.appendChild(pill);
          if (v.available && first < 0) first = k;
        });
        if (first < 0) first = 0;
        pills.querySelectorAll('input')[first].checked = true;
        qaSelect(p, first);
        btn.focus({ preventScroll: true });
        setOpen(qa, true);
      });
    }
  }

  /* Footer link columns: accordions on phones */
  var phoneMq = window.matchMedia('(max-width: 809px)');
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.fh-f-toggle');
    if (!t || !phoneMq.matches) return;
    var col = t.closest('.fh-f-col');
    var open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // After a newsletter post the store reloads with ?customer_posted=true: show the thank-you
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    rememberPopup();
    var nl = document.querySelector('.fh-newsletter');
    if (nl) setTimeout(function () { nl.scrollIntoView({ block: 'center' }); }, 300);
  }
})();
